import { RegisterMode } from '@app/dev/actions/terminal';
import { PopupContext } from '@app/dev/contexts/popup';
import { POPUPS } from '@common/constants/popups';
import { useTranslation } from '@common/hooks/translation';
import React, { useContext } from 'react';
import _ from 'lodash';

import { useDispatch, useSelector } from 'react-redux';

import './style.scss';

const RfidCheck = () => {
  const { isCardRegistered } = useSelector((state) => state.terminal);
  const dispatch = useDispatch();
  const [{ closePopup, openPopup }] = useContext(PopupContext);
  const t = useTranslation();

  !_.isEmpty(isCardRegistered) && openPopup(POPUPS.REGISTER_BY_CNP_POPUP);

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('Registration')}</h3>
      <div className="popup-main-content">
        <div className="rfid-card-icon-wrapper">
          <i className="global-icon icon-rfid-scan rfid-icon" />
        </div>
        <p className="text-center">{t('Please input new RFID card for player registration')}</p>
      </div>
      <button
        type="button"
        onClick={() => {
          closePopup();
          dispatch(RegisterMode(false));
        }}
        className="popup-cancel-button rfid-cancle"
      >
        {t('Cancel')}
      </button>
    </div>
  );
};

export default RfidCheck;
